import { _, Component, Container, React, Route } from "utils";
import { App, Creators, FairStore, JobStore, StandStore } from "model";
import { ActiveJobs, JobDetails } from "components";
import { Switch } from "react-router-dom";
import "../../pages/activitypage.less";

class Jobs extends Component {
  static getStores() {
    return [FairStore, JobStore];
  }

  static calculateState() {
    var jobs = JobStore.getJobs();
    var title = FairStore.getFairTitle(_("Jobs"));
    let fairData = FairStore.getFairData();
    let isFairActive = fairData
      ? fairData.active
        ? fairData.active
        : false
      : false;

    return {
      jobs: jobs,
      title: title,
      isFairActive,
    };
  }

  getStandId() {
    var { stand } = this.props.match.params;
    return StandStore.findStandId(stand);
  }

  getPavilionId() {
    var { pavilion } = this.props.match.params;
    return FairStore.getPavilionId(pavilion);
  }

  getJobsByPavilion() {
    let pavilionJobs = [];
    let otherJobs = [];
    let pavilionId = this.getPavilionId() ? this.getPavilionId() : 0;

    if (this.state.jobs) {
      this.state.jobs.map((job) => {
        if (job.offerPavilion == pavilionId && job.offerPavilion != 0) {
          pavilionJobs[pavilionJobs.length] = job;
        } else {
          otherJobs[otherJobs.length] = job;
        }
      });
    }
    return {
      pavilionJobs: pavilionJobs,
      otherJobs: otherJobs,
    };
  }

  componentDidMount() {
    var standId = this.getStandId();
    Creators.loadJobs("", standId);
  }

  render() {
    var { pavilion, stand } = this.props.match.params;
    var { title, jobs, isFairActive } = this.state;

    let pageTitle =
      stand.toLowerCase() === "educentar" ? _("Educations") : _("Jobs");

    App.setPageTitle(title);

    let jobsByPavilion = this.getJobsByPavilion();
    let { otherJobs } = jobsByPavilion;
    return (
      <Route
        path="/pavilion/:pavilion/stand/:stand/offers"
        render={() => (
          <div className="col-12">
            <Switch>
              <Route
                exact={true}
                path="/pavilion/:pavilion/stand/:stand/offers/:jobId"
                render={() => (
                  <div>
                    <JobDetails />
                  </div>
                )}
              />
              <Route
                exact={true}
                path="/pavilion/:pavilion/stand/:stand/offers"
                render={() => (
                  <div>
                    <h1 className="display-4">{pageTitle}</h1>
                    <ActiveJobs
                      data={jobsByPavilion.pavilionJobs}
                      baseUrl={`/pavilion/${pavilion}/stand/${stand}/offers/`}
                      isFairActive={isFairActive}
                    />
                    <br />
                    <h1 className="display-6" hidden={!(otherJobs.length > 0)}>
                      {_("Other exhibitor jobs")}
                    </h1>
                    <ActiveJobs
                      data={otherJobs}
                      baseUrl={`/pavilion/${pavilion}/stand/${stand}/offers/`}
                      isFairActive={isFairActive}
                    />
                  </div>
                )}
              />
            </Switch>
          </div>
        )}
      />
    );
  }
}

export default Container.create(Jobs);



// WEBPACK FOOTER //
// ./src/modules/components/activities/jobs.js